import { GOOGLE_MAPS_SEARCH_URL } from '../contstants/googleMaps';

export const goToMaps = (address) => {
	const googleMapsLink = `${GOOGLE_MAPS_SEARCH_URL}?q=${address}`;

	window.open(googleMapsLink, '_blank').focus();
};
